import Vue from 'vue';
import Router from 'vue-router';
import Index from '../components/Index';
import Fruit from '../components/Fruit';
import Product from '../components/Product';
import Searchproduct from '../components/Searchproduct';
import Support from '../components/Support';
import Abouts from '../components/Abouts';
import Career from '../components/Career';
import Offices from '../components/Offices';
import Newsevents from '../components/Newsevents';
import Newsdetail from '../components/Newsdetail';
import Contact from '../components/Contact';
import Login from '../components/Login';
import Register from '../components/Register';
import Password from '../components/Password';
import resetPassword from '../components/resetPassword';
import PersonalInformation from '../components/PersonalInformation';
import Cart from '../components/Cart';
import Payment from '../components/Payment';
import orderDetail from '../components/PersonaComponents/orderDetail';
import afterSales from '../components/afterSales';

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        showhidder: true,
      },
    },
    {
      path: '/fruit',
      name: 'Fruit',
      component: Fruit,
      meta: {
        showhidder: true,
      },
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product,
      meta: {
        showhidder: false,
      },
    },
    {
      path: '/Searchproduct',
      name: 'Searchproduct',
      component: Searchproduct,
    },
    {
      path: '/Support',
      name: 'Support',
      component: Support,
    },
    {
      path: '/Abouts',
      name: 'Abouts',
      component: Abouts,
    },
    {
      path: '/Career',
      name: 'Career',
      component: Career,
    },
    {
      path: '/Offices',
      name: 'Offices',
      component: Offices,
    },
    {
      path: '/Newsevents',
      name: 'Newsevents',
      component: Newsevents,
    },
    {
      path: '/Newsdetail',
      name: 'Newsdetail',
      component: Newsdetail,
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/Password',
      name: 'Password',
      component: Password,
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword,
    },
    {
      path: '/PersonalInformation',
      name: 'PersonalInformation',
      component: PersonalInformation,
    },
    {
      path: '/Cart',
      name: 'Cart',
      component: Cart,
    },
    {
      path: '/Payment',
      name: 'Payment',
      component: Payment,
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
    },
    {
      path: '/afterSales',
      name: 'afterSales',
      component: afterSales,
    },
  ],
});
